import { createUseStyles } from 'react-jss';
import { Classes } from 'jss';
import { grayPalette } from '@tcl-argon-colors/colors';

export const useCardStyles: (
  data?: { isCollapsible: boolean } & { theme?: Jss.Theme },
) => Classes<'root' | 'title' | 'cardContentWrapper' | 'cardContentRoot'> = createUseStyles({
  root: {
    overflowY: ({ isCollapsible }) => {
      return isCollapsible ? 'hidden' : 'auto';
    },
    height: '100%',
    maxHeight: 'inherit',
    width: '100%',
    boxSizing: 'border-box',
    padding: '24px 0px 24px 24px',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0px 3px 4px 2px #E9E9EA',
    borderRadius: '10px',
    '@supports not selector(::-webkit-scrollbar)': {
      scrollbarWidth: 'thin',
      scrollbarColor: `${grayPalette.gray45} transparent`,
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '16px',
      background: `${grayPalette.gray45}`,
      border: '6px solid rgba(0, 0, 0, 0)',
      backgroundClip: 'padding-box',
    },
    '&::-webkit-scrollbar': {
      border: 'none',
      width: '16px',
    },
    '&::-webkit-scrollbar-button': {
      width: '0',
      height: '0',
      display: 'none',
    },
    '&::-webkit-scrollbar-corner': {
      backgroundColor: 'transparent',
    },
  },
  title: {
    fontFamily: 'inherit',
    fontSize: '20px',
    fontWeight: 'bold',
    lineHeight: '20px',
    paddingBottom: '24px',
    margin: '0',
  },
  cardContentRoot: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 'inherit',
    overflow: 'hidden',
  },
  cardContentWrapper: {
    overflowY: 'scroll',
    flexGrow: 1,
    paddingRight: '8px',
    '@supports not selector(::-webkit-scrollbar)': {
      scrollbarWidth: 'thin',
      scrollbarColor: `${grayPalette.gray45} transparent`,
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '16px',
      background: `${grayPalette.gray45}`,
      border: '6px solid rgba(0, 0, 0, 0)',
      backgroundClip: 'padding-box',
    },
    '&::-webkit-scrollbar': {
      border: 'none',
      width: '16px',
    },
    '&::-webkit-scrollbar-button': {
      width: '0',
      height: '0',
      display: 'none',
    },
    '&::-webkit-scrollbar-corner': {
      backgroundColor: 'transparent',
    },
  },
});
